import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataInteger,
  ODataEnum
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { translate } from '../trans'
import { i18n } from '@/plugins/i18n';
import store from '@/store'

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 3
});

const formatter2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

/*[
  {
    text: "SIN/CERT",
    align: "left",
    value: "Member/SinCert",
    sortable: true,
    visible: true,
    type: "string",
    clickFunc: "sinClicked",
    expand: true,
    expandValue: "Member",
    displayFunc: "sinDisplayFunc",
    searchable: true
  },
  {
    text: "Status",
    value: "Status",
    sortable: true,
    visible: true,
    type: "double-string",
    searchable: true
  }
]*/

const AdjustmentsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("PlanId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.certificate",
    type: new ODataString("Member/SINCERT"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("Member/FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("Member/LastName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.adjustments.coverage_name",
    type: new ODataString("Coverage/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new ODataHeader({
    type: new ODataString("Coverage/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.coverage",
    type: new ODataString("Coverage/Translations[]/Name", {
      getString: (item) => translate2(item.Coverage, "Name")
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "Coverage/Name"
  }),
  new ODataHeader({
    title: "headers.adjustments.no_of_terms",
    type: new ODataInteger("NoOfTerms"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  /*new ODataHeader({
    title: "Effective Date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),*/
  new ODataHeader({
    title: "components.plancreationwizard.volume",
    type: new ODataDecimal("Volume", {
      getString: (item, type) => {
        const value = item.Value;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter2.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.premium_rate",
    type: new ODataDecimal("Rate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.adjustments.premium_amount",
    type: new ODataDecimal("Amount", {
      getString: (item, type) => {
        const value = item.Amount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.PPTax",
    type: new ODataDecimal("PPTax", {
      getString: (item, type) => {
        const value = item.PPTax;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.RSTax",
    type: new ODataDecimal("RSTax", {
      getString: (item, type) => {
        const value = item.RSTax;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.GSTax",
    type: new ODataDecimal("GSTax", {
      getString: (item, type) => {
        const value = item.GSTax;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.PSTax",
    type: new ODataDecimal("PSTax", {
      getString: (item, type) => {
        const value = item.PSTax;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.HSTax",
    type: new ODataDecimal("HSTax", {
      getString: (item, type) => {
        const value = item.HSTax;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.adjustments.total",
    type: new ODataDecimal("Total", {
      getString: (item, type) => {
        const value = item.Total;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter2.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    type: new ODataString("OriginalBillingTerm/Number"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.adjustments.original_billing_term",
    type: new ODataString("OriginalBillingTerm/Name", {
      getString: item => {
        return translate2(item.OriginalBillingTerm, 'Name');
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "OriginalBillingTerm/Number"
  }),
  new ODataHeader({
    type: new ODataString("OriginalBillingTerm/Translations/"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataEnum("Status", {
      getString: (item) => {
        return i18n.t("enums." + item.Status);
      },
      dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.AdjustmentStatus:[]
    }),

    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataEnum("Type", {
      getString: (item) => {
        return i18n.t("enums." + item.Type);
      },
      dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.AdjustmentType:[]
    }),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default AdjustmentsHeaders;
